export interface WorkforceStaff {
  staffId: string;
  entraObjectId: string;
  displayName: string;
  email: string;
  jobTitle?: string | null;
  mobilePhone?: string | null;
  active: boolean;
  lastSyncedAt: string;
  clientAssignments: StaffClientAssignment[];
}

export interface StaffAssignmentType {
  staffAssignmentTypeId: number;
  code: string;
  name: string;
  sortOrder: number;
}

export interface StaffClientAssignment {
  staffClientAssignmentId: string;
  staffId: string;
  staffDisplayName: string;
  staffEmail: string;
  mCode: string;
  clientName?: string;
  cCode?: string | null;
  staffAssignmentTypeId: number;
  assignmentTypeCode: string;
  assignmentTypeName: string;
  active: boolean;
  effectiveFrom: string;
  effectiveTo?: string | null;
  createdBy?: string | null;
  closedBy?: string | null;
}

export interface UpsertStaffClientAssignment {
  mCode: string;
  cCode?: string | null;
  staffAssignmentTypeId: number;
}

export interface UpsertClientStaffAssignment {
  staffId: string;
  staffAssignmentTypeId: number;
}

export interface WorkforceStaffSyncResult {
  created: number;
  updated: number;
  deactivated: number;
  totalFromEntra: number;
}

export const StaffAssignmentTypeCodes = {
  SalesAgent: 'SalesAgent',
  PrimaryAccountManager: 'PrimaryAccountManager',
  SecondaryAccountManager: 'SecondaryAccountManager',
  PrimaryBillingManager: 'PrimaryBillingManager',
  SecondaryBillingManager: 'SecondaryBillingManager'
} as const;
